/** New reservation session length (seconds) — default countdown when a session starts. */
export const RESERVATION_DEFAULT_DURATION_SECONDS = 12 * 60

/** Upper cap (seconds): "+2 min" cannot extend total duration beyond this (was effectively higher before). */
export const RESERVATION_MAX_DURATION_SECONDS = 50 * 60
